import React from 'react';

import { Checkbox as UIKITCheckbox } from '@vchasno/ui-kit';

import cn from 'classnames';
import PropTypes from 'prop-types';

import css from './checkbox.css';

const Input = (props) => {
    const handleChange = (evt) => {
        if (!props.disabled && typeof props.onChange === 'function') {
            props.onChange(evt.target.checked, evt.shiftKey);
        }
    };

    return (
        <input
            disabled={props.disabled}
            name={props.name}
            className={css.input}
            type="checkbox"
            onChange={handleChange}
            checked={props.checked}
            id={props.id}
            data-qa={props.dataQa}
        />
    );
};

export const CheckboxLegacy = (props) => {
    const fakeInputClass = cn(css.fakeInput, {
        [css.fakeInputPartial]: props.partialChecked,
        [css.fakeInputBig]: props.sizeBig,
        [css.fakeInputBorderNone]: props.borderNone,
        [css.blueTheme]: props.color === 'blue',
        [css.whiteTheme]: props.color === 'white',
        [css.deepSkyBlueTheme]: props.color === 'deepSkyBlue',
    });

    const rootClasses = cn(
        css.root,
        props.alignLabel === 'top' ? css.rootTop : css.rootCenter,
        props.className,
    );

    const onlyInputClickRootClasses = cn(
        css.onlyInputClickRoot,
        props.alignLabel === 'top' ? css.rootTop : css.rootCenter,
        props.className,
    );

    const preventTwiceClickPropagation = (event) => {
        if (event.target?.type !== 'checkbox') {
            event.stopPropagation();
        }
    };

    return (
        <div className={css.wrapper}>
            {props.isOnlyInputClick && (
                <>
                    <label
                        onClick={preventTwiceClickPropagation}
                        className={onlyInputClickRootClasses}
                    >
                        <Input {...props} />
                        <span className={fakeInputClass} />
                    </label>
                    <span
                        className={props.disabled ? css.textDisabled : css.text}
                    >
                        {props.text}
                    </span>
                </>
            )}
            {!props.isOnlyInputClick && (
                <label
                    onClick={preventTwiceClickPropagation}
                    className={rootClasses}
                >
                    <Input {...props} />
                    <span className={fakeInputClass} />
                    <span
                        className={props.disabled ? css.textDisabled : css.text}
                    >
                        {props.text}
                    </span>
                </label>
            )}
        </div>
    );
};

CheckboxLegacy.propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
    partialChecked: PropTypes.bool,
    sizeBig: PropTypes.bool,
    borderNone: PropTypes.bool,
    dataQa: PropTypes.string,
    id: PropTypes.string,
    color: PropTypes.string,
    alignLabel: PropTypes.oneOf(['center', 'top']),
    className: PropTypes.string,
    /**
     * @deprecated
     */
    isOnlyInputClick: PropTypes.bool,
};

CheckboxLegacy.defaultProps = {
    checked: false,
    partialChecked: false,
    color: 'blue',
    alignLabel: 'top',
};

/**
 * @deprecated
 * use @vchasno/ui-kit/Checkbox instead
 */
const CheckboxProxy = (props) => {
    const handleChange = (evt) => {
        if (!props.disabled && typeof props.onChange === 'function') {
            props.onChange(evt.target.checked, evt.shiftKey);
        }
    };

    return (
        <UIKITCheckbox
            {...props}
            label={props.label || props.text}
            onChange={handleChange}
            partial={props.partialChecked}
        />
    );
};

CheckboxProxy.propTypes = CheckboxLegacy.propTypes;

export default CheckboxProxy;
